<!--  -->
<template>
  <div class="header df-between"  :style="{'padding-top':utils.isIphoneX()?'50px':'30px'}">
    <i @click="handleBack()" class="back" v-if="isBack"></i>
    <!-- <img src="../../assets/images/i-arrow-left.png" alt="" class="back" > -->
    <div class='title df-center'>{{headTitle}}</div>
    <i class='iconfont'></i>
  </div>
</template>

<script>
  export default {
    props:{
      headTitle:{// 标题名称
        type:String,
        default:''
      },
      isBack:{ //是否返回
        type:Boolean,
        default:true
      },
      pageName:{ //页面名称
        type:String,
        default:''
      }
    },
    data() {
      return {}
    },
    created() {},
    methods: {
      handleBack(){
        if(this.pageName == 'handMonitorRrported'){
          this.$emit('handleBack')
          return
        }
        if(this.isBack){
          this.$router.go('-1')
        }
      }
    },
  }
</script>
<style lang='scss' scoped>
  .header {
    padding: 15px;
    font-size: 17px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #000000;
    .title{
      height: 20px;
      font-size: 17px;
    }
    .back {
      /* margin-right: auto; */
      width: 22px;
      height: 22px;
      background: url('../../assets/images/i-arrow-left.png');
      background-size: 100% 100%;
    }
  }
</style>
